import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";
import { fetchDineCategoryDropdown } from "./Dine/DineList/FetchCategoryOptions";
import { fetchServicesCategoryDropdown } from "./Services/ServicesList/FetchCategoryOptions";
import { fetchShopCategoryDropdown } from "./Shop/ShopList/FetchCategoryOptions";
import { FetchSubModule } from "./Shop/ShopList/ShopListOptions";
export const getShopDineDrillDownData: { [key in ModuleConfig]: ModuleFields[] } = {
  landingPageContent: [
    {
      fieldName: "Image",
      fieldValue: "image",
      className: "col-span-6",
      type: "image",
      name: "image",
      formType: "file",
      usedFileType: "image/*",
      label: "Image",
      placeholder: "Select Image",
      validation: { required: "Image is required" },
    },
    {
      fieldName: "Title (EN)",
      fieldValue: "name",
      className: "col-span-6",
      type: "text",
      name: "name",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "name_malay",
      className: "col-span-6",
      type: "text",
      name: "name_malay",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "name_mandarin",
      className: "col-span-6",
      type: "text",
      name: "pageTitname_mandarinleZh",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
    },
    {
      fieldName: "Description (EN)",
      fieldValue: "description",
      className: "col-span-6",
      type: "text",
      name: "description",
      formType: "richText",
      label: "Description (EN)",
      placeholder: "Enter Description (EN)",
      validation: { required: "Description (EN) is required" },
    },
    {
      fieldName: "Description (MS)",
      fieldValue: "description_ms",
      className: "col-span-6",
      type: "text",
      name: "description_ms",
      formType: "richText",
      label: "Description (MS)",
      placeholder: "Enter Description (MS)",
      // validation: { required: "Description (MS) is required" },
    },
    {
      fieldName: "Description (ZH)",
      fieldValue: "description_zh",
      className: "col-span-6",
      type: "text",
      name: "description_zh",
      formType: "richText",
      label: "Description (ZH)",
      placeholder: "Enter Description (ZH)",
      // validation: { required: "Description (ZH) is required" },
    },
    {
      fieldName: "Redirect Url",
      fieldValue: "link",
      className: "col-span-6",
      type: "text",
      name: "link",
      formType: "input",
      label: "Redirect Url",
      placeholder: "Enter Redirect Url",
      validation: { required: "Redirect Url is required" },
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    },
  ],
  shopCategoriesPageContent: [
    {
      fieldName: "Image",
      fieldValue: "image",
      className: "col-span-6",
      type: "image",
      name: "image",
      formType: "file",
      usedFileType: "image/*",
      label: "Image",
      placeholder: "Select Image",
      validation: { required: "Image is required" },
    },
    {
      fieldName: "Banner Image",
      fieldValue: "banner_image",
      className: "col-span-6",
      type: "image",
      name: "banner_image",
      formType: "file",
      usedFileType: "image/*",
      label: "Banner Image",
      placeholder: "Select Banner Image",
      validation: { required: "Banner Image is required" },
    },
    {
      fieldName: "Title (EN)",
      fieldValue: "name",
      className: "col-span-6",
      type: "text",
      name: "name",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "name_ms",
      className: "col-span-6",
      type: "text",
      name: "name_ms",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "name_zh",
      className: "col-span-6",
      type: "text",
      name: "name_zh",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
    },
    {
      fieldName: "Description (EN)",
      fieldValue: "description",
      className: "col-span-6",
      type: "text",
      name: "description",
      formType: "richText",
      label: "Description (EN)",
      placeholder: "Enter Description (EN)",
      validation: { required: "Description (EN) is required" },
    },
    {
      fieldName: "Description (MS)",
      fieldValue: "description_ms",
      className: "col-span-6",
      type: "text",
      name: "description_ms",
      formType: "richText",
      label: "Description (MS)",
      placeholder: "Enter Description (MS)",
      // validation: { required: "Description (MS) is required" },
    },
    {
      fieldName: "Description (ZH)",
      fieldValue: "description_zh",
      className: "col-span-6",
      type: "text",
      name: "description_zh",
      formType: "richText",
      label: "Description (ZH)",
      placeholder: "Enter Description (ZH)",
      // validation: { required: "Description (ZH) is required" },
    },
    {
      fieldName: "Redirect Url",
      fieldValue: "link",
      className: "col-span-6",
      type: "text",
      name: "link",
      formType: "input",
      label: "Redirect Url",
      placeholder: "Enter Redirect Url",
      // validation: { required: "Redirect Url is required" },
    },
    {
      fieldName: "Airports",
      fieldValue: "airport",
      className: "col-span-6",
      type: "select",
      name: "airport",
      formType: "multiSelect",
      label: "Airports",
      placeholder: "Select Airports",
      options: [
        { label: "KLIA1", value: "klia1" },
        { label: "KLIA2", value: "klia2" },
      ],
      validation: { required: "Select at least one airport" },
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    },
  ],
  dineCategoriesPageContent: [
    {
      fieldName: "Image",
      fieldValue: "image",
      className: "col-span-6",
      type: "image",
      name: "image",
      formType: "file",
      usedFileType: "image/*",
      label: "Image",
      placeholder: "Select Image",
      validation: { required: "Image is required" },
    },
    {
      fieldName: "Banner Image",
      fieldValue: "banner_image",
      className: "col-span-6",
      type: "image",
      name: "banner_image",
      formType: "file",
      usedFileType: "image/*",
      label: "Banner Image",
      placeholder: "Select Banner Image",
      validation: { required: "Banner Image is required" },
    },
    {
      fieldName: "Title (EN)",
      fieldValue: "name",
      className: "col-span-6",
      type: "text",
      name: "name",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "name_ms",
      className: "col-span-6",
      type: "text",
      name: "name_ms",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "name_zh",
      className: "col-span-6",
      type: "text",
      name: "name_zh",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
    },
    {
      fieldName: "Description (EN)",
      fieldValue: "description",
      className: "col-span-6",
      type: "text",
      name: "description",
      formType: "richText",
      label: "Description (EN)",
      placeholder: "Enter Description (EN)",
      validation: { required: "Description (EN) is required" },
    },
    {
      fieldName: "Description (MS)",
      fieldValue: "description_ms",
      className: "col-span-6",
      type: "text",
      name: "description_ms",
      formType: "richText",
      label: "Description (MS)",
      placeholder: "Enter Description (MS)",
      // validation: { required: "Description (MS) is required" },
    },
    {
      fieldName: "Description (ZH)",
      fieldValue: "description_zh",
      className: "col-span-6",
      type: "text",
      name: "description_zh",
      formType: "richText",
      label: "Description (ZH)",
      placeholder: "Enter Description (ZH)",
      // validation: { required: "Description (ZH) is required" },
    },
    {
      fieldName: "Redirect Url",
      fieldValue: "link",
      className: "col-span-6",
      type: "text",
      name: "link",
      formType: "input",
      label: "Redirect Url",
      placeholder: "Enter Redirect Url",
      // validation: { required: "Redirect Url is required" },
    },
    {
      fieldName: "Airports",
      fieldValue: "airport",
      className: "col-span-6",
      type: "select",
      name: "airport",
      formType: "multiSelect",
      label: "Airports",
      placeholder: "Select Airports",
      options: [
        { label: "KLIA1", value: "klia1" },
        { label: "KLIA2", value: "klia2" },
      ],
      validation: { required: "Select at least one airport" },
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    },
  ],
  servicesCategoriesPageContent: [
    {
      fieldName: "Image",
      fieldValue: "image",
      className: "col-span-6",
      type: "image",
      name: "image",
      formType: "file",
      usedFileType: "image/*",
      label: "Image",
      placeholder: "Select Image",
      validation: { required: "Image is required" },
    },
    {
      fieldName: "Banner Image",
      fieldValue: "banner_image",
      className: "col-span-6",
      type: "image",
      name: "banner_image",
      formType: "file",
      usedFileType: "image/*",
      label: "Banner Image",
      placeholder: "Select Banner Image",
      validation: { required: "Banner Image is required" },
    },
    {
      fieldName: "Title (EN)",
      fieldValue: "name",
      className: "col-span-6",
      type: "text",
      name: "name",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "name_ms",
      className: "col-span-6",
      type: "text",
      name: "name_ms",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "name_zh",
      className: "col-span-6",
      type: "text",
      name: "name_zh",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
    },
    {
      fieldName: "Description (EN)",
      fieldValue: "description",
      className: "col-span-6",
      type: "text",
      name: "description",
      formType: "richText",
      label: "Description (EN)",
      placeholder: "Enter Description (EN)",
      validation: { required: "Description (EN) is required" },
    },
    {
      fieldName: "Description (MS)",
      fieldValue: "description_ms",
      className: "col-span-6",
      type: "text",
      name: "description_ms",
      formType: "richText",
      label: "Description (MS)",
      placeholder: "Enter Description (MS)",
      // validation: { required: "Description (MS) is required" },
    },
    {
      fieldName: "Description (ZH)",
      fieldValue: "description_zh",
      className: "col-span-6",
      type: "text",
      name: "description_zh",
      formType: "richText",
      label: "Description (ZH)",
      placeholder: "Enter Description (ZH)",
      // validation: { required: "Description (ZH) is required" },
    },
    {
      fieldName: "Redirect Url",
      fieldValue: "link",
      className: "col-span-6",
      type: "text",
      name: "link",
      formType: "input",
      label: "Redirect Url",
      placeholder: "Enter Redirect Url",
      // validation: { required: "Redirect Url is required" },
    },
    {
      fieldName: "Airports",
      fieldValue: "airport",
      className: "col-span-6",
      type: "select",
      name: "airport",
      formType: "multiSelect",
      label: "Airports",
      placeholder: "Select Airports",
      options: [
        { label: "KLIA1", value: "klia1" },
        { label: "KLIA2", value: "klia2" },
      ],
      validation: { required: "Select at least one airport" },
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    },
  ],
  landingPageHeading: [
    {
      fieldName: "Page Banner Image",
      fieldValue: "field_page_banner_image",
      className: "col-span-6",
      type: "image",
      name: "field_page_banner_image",
      formType: "file",
      label: "Page Banner Image",
      placeholder: "Upload Page Banner Image",
      validation: { required: "At least one Image is required" },
    },
    {
      fieldName: "Page Title (EN)",
      fieldValue: "field_page_title_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_en",
      formType: "input",
      label: "Page Title (EN)",
      placeholder: "Enter Page Title (English)",
      validation: { required: "At least one title is required" },
    },
    {
      fieldName: "Page Title (MS)",
      fieldValue: "field_page_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_ms",
      formType: "input",
      label: "Page Title (MS)",
      placeholder: "Enter Page Title (Malay)",
    },
    {
      fieldName: "Page Title (ZH)",
      fieldValue: "field_page_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_zh",
      formType: "input",
      label: "Page Title (ZH)",
      placeholder: "Enter Page Title (Mandarin)",
    },
    {
      fieldName: "Page Description (EN)",
      fieldValue: "field_page_description_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_en",
      formType: "richText",
      label: "Page Description (EN)",
      placeholder: "Enter Page Description (English)",
      // validation: { required: "At least one Description is required" },
    },
    {
      fieldName: "Page Description (MS)",
      fieldValue: "field_page_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_ms",
      formType: "richText",
      label: "Page Description (MS)",
      placeholder: "Enter Page Description (Malay)",
    },
    {
      fieldName: "Page Description (ZH)",
      fieldValue: "field_page_description_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_zh",
      formType: "richText",
      label: "Page Description (ZH)",
      placeholder: "Enter Page Description (Mandarin)",
    },
  ],
  shopCategoriesPageHeading: [
    {
      fieldName: "Page Banner Image",
      fieldValue: "field_page_banner_image",
      className: "col-span-6",
      type: "image",
      name: "field_page_banner_image",
      formType: "file",
      usedFileType: "image/*",
      label: "Page Banner Image",
      placeholder: "Upload Page Banner Image",
      validation: { required: "At least one Image is required" },
    },
    {
      fieldName: "Page Title (EN)",
      fieldValue: "field_page_title_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_en",
      formType: "input",
      label: "Page Title (EN)",
      placeholder: "Enter Page Title (English)",
      validation: { required: "At least one title is required" },
    },
    {
      fieldName: "Page Title (MS)",
      fieldValue: "field_page_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_ms",
      formType: "input",
      label: "Page Title (MS)",
      placeholder: "Enter Page Title (Malay)",
    },
    {
      fieldName: "Page Title (ZH)",
      fieldValue: "field_page_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_zh",
      formType: "input",
      label: "Page Title (ZH)",
      placeholder: "Enter Page Title (Mandarin)",
    },
    {
      fieldName: "Page Description (EN)",
      fieldValue: "field_page_description_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_en",
      formType: "richText",
      label: "Page Description (EN)",
      placeholder: "Enter Page Description (English)",
      // validation: { required: "At least one Description is required" },
    },
    {
      fieldName: "Page Description (MS)",
      fieldValue: "field_page_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_ms",
      formType: "richText",
      label: "Page Description (MS)",
      placeholder: "Enter Page Description (Malay)",
    },
    {
      fieldName: "Page Description (ZH)",
      fieldValue: "field_page_description_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_zh",
      formType: "richText",
      label: "Page Description (ZH)",
      placeholder: "Enter Page Description (Mandarin)",
    },
  ],
  dineCategoriesPageHeading: [
    {
      fieldName: "Page Banner Image",
      fieldValue: "field_page_banner_image",
      className: "col-span-6",
      type: "image",
      name: "field_page_banner_image",
      formType: "file",
      usedFileType: "image/*",
      label: "Page Banner Image",
      placeholder: "Upload Page Banner Image",
      validation: { required: "At least one Image is required" },
    },
    {
      fieldName: "Page Title (EN)",
      fieldValue: "field_page_title_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_en",
      formType: "input",
      label: "Page Title (EN)",
      placeholder: "Enter Page Title (English)",
      validation: { required: "At least one title is required" },
    },
    {
      fieldName: "Page Title (MS)",
      fieldValue: "field_page_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_ms",
      formType: "input",
      label: "Page Title (MS)",
      placeholder: "Enter Page Title (Malay)",
    },
    {
      fieldName: "Page Title (ZH)",
      fieldValue: "field_page_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_zh",
      formType: "input",
      label: "Page Title (ZH)",
      placeholder: "Enter Page Title (Mandarin)",
    },
    {
      fieldName: "Page Description (EN)",
      fieldValue: "field_page_description_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_en",
      formType: "richText",
      label: "Page Description (EN)",
      placeholder: "Enter Page Description (English)",
      // validation: { required: "At least one Description is required" },
    },
    {
      fieldName: "Page Description (MS)",
      fieldValue: "field_page_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_ms",
      formType: "richText",
      label: "Page Description (MS)",
      placeholder: "Enter Page Description (Malay)",
    },
    {
      fieldName: "Page Description (ZH)",
      fieldValue: "field_page_description_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_zh",
      formType: "richText",
      label: "Page Description (ZH)",
      placeholder: "Enter Page Description (Mandarin)",
    },
  ],
  servicesCategoriesPageHeading: [
    {
      fieldName: "Page Banner Image",
      fieldValue: "field_page_banner_image",
      className: "col-span-6",
      type: "image",
      name: "field_page_banner_image",
      formType: "file",
      usedFileType: "image/*",
      label: "Page Banner Image",
      placeholder: "Upload Page Banner Image",
      validation: { required: "At least one Image is required" },
    },
    {
      fieldName: "Page Title (EN)",
      fieldValue: "field_page_title_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_en",
      formType: "input",
      label: "Page Title (EN)",
      placeholder: "Enter Page Title (English)",
      validation: { required: "At least one title is required" },
    },
    {
      fieldName: "Page Title (MS)",
      fieldValue: "field_page_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_ms",
      formType: "input",
      label: "Page Title (MS)",
      placeholder: "Enter Page Title (Malay)",
    },
    {
      fieldName: "Page Title (ZH)",
      fieldValue: "field_page_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_zh",
      formType: "input",
      label: "Page Title (ZH)",
      placeholder: "Enter Page Title (Mandarin)",
    },
    {
      fieldName: "Page Description (EN)",
      fieldValue: "field_page_description_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_en",
      formType: "richText",
      label: "Page Description (EN)",
      placeholder: "Enter Page Description (English)",
      // validation: { required: "At least one Description is required" },
    },
    {
      fieldName: "Page Description (MS)",
      fieldValue: "field_page_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_ms",
      formType: "richText",
      label: "Page Description (MS)",
      placeholder: "Enter Page Description (Malay)",
    },
    {
      fieldName: "Page Description (ZH)",
      fieldValue: "field_page_description_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_zh",
      formType: "richText",
      label: "Page Description (ZH)",
      placeholder: "Enter Page Description (Mandarin)",
    },
  ],
  shopListPageHeading: [
    {
      fieldName: "Page Banner Image",
      fieldValue: "field_page_banner_image",
      className: "col-span-6",
      type: "image",
      name: "field_page_banner_image",
      formType: "file",
      usedFileType: "image/*",
      label: "Page Banner Image",
      placeholder: "Upload Page Banner Image",
      validation: { required: "At least one Image is required" },
    },
    {
      fieldName: "Page Title (EN)",
      fieldValue: "field_page_title_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_en",
      formType: "input",
      label: "Page Title (EN)",
      placeholder: "Enter Page Title (English)",
      validation: { required: "At least one title is required" },
    },
    {
      fieldName: "Page Title (MS)",
      fieldValue: "field_page_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_ms",
      formType: "input",
      label: "Page Title (MS)",
      placeholder: "Enter Page Title (Malay)",
    },
    {
      fieldName: "Page Title (ZH)",
      fieldValue: "field_page_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_zh",
      formType: "input",
      label: "Page Title (ZH)",
      placeholder: "Enter Page Title (Mandarin)",
    },
    {
      fieldName: "Page Description (EN)",
      fieldValue: "field_page_description_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_en",
      formType: "richText",
      label: "Page Description (EN)",
      placeholder: "Enter Page Description (English)",
      // validation: { required: "At least one Description is required" },
    },
    {
      fieldName: "Page Description (MS)",
      fieldValue: "field_page_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_ms",
      formType: "richText",
      label: "Page Description (MS)",
      placeholder: "Enter Page Description (Malay)",
    },
    {
      fieldName: "Page Description (ZH)",
      fieldValue: "field_page_description_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_zh",
      formType: "richText",
      label: "Page Description (ZH)",
      placeholder: "Enter Page Description (Mandarin)",
    },
  ],
  dineListPageHeading: [
    {
      fieldName: "Page Banner Image",
      fieldValue: "field_page_banner_image",
      className: "col-span-6",
      type: "image",
      name: "field_page_banner_image",
      formType: "file",
      usedFileType: "image/*",
      label: "Page Banner Image",
      placeholder: "Upload Page Banner Image",
      validation: { required: "At least one Image is required" },
    },
    {
      fieldName: "Page Title (EN)",
      fieldValue: "field_page_title_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_en",
      formType: "input",
      label: "Page Title (EN)",
      placeholder: "Enter Page Title (English)",
      validation: { required: "At least one title is required" },
    },
    {
      fieldName: "Page Title (MS)",
      fieldValue: "field_page_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_ms",
      formType: "input",
      label: "Page Title (MS)",
      placeholder: "Enter Page Title (Malay)",
    },
    {
      fieldName: "Page Title (ZH)",
      fieldValue: "field_page_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_zh",
      formType: "input",
      label: "Page Title (ZH)",
      placeholder: "Enter Page Title (Mandarin)",
    },
    {
      fieldName: "Page Description (EN)",
      fieldValue: "field_page_description_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_en",
      formType: "richText",
      label: "Page Description (EN)",
      placeholder: "Enter Page Description (English)",
      // validation: { required: "At least one Description is required" },
    },
    {
      fieldName: "Page Description (MS)",
      fieldValue: "field_page_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_ms",
      formType: "richText",
      label: "Page Description (MS)",
      placeholder: "Enter Page Description (Malay)",
    },
    {
      fieldName: "Page Description (ZH)",
      fieldValue: "field_page_description_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_zh",
      formType: "richText",
      label: "Page Description (ZH)",
      placeholder: "Enter Page Description (Mandarin)",
    },
  ],
  servicesListPageHeading: [
    {
      fieldName: "Page Banner Image",
      fieldValue: "field_page_banner_image",
      className: "col-span-6",
      type: "image",
      name: "field_page_banner_image",
      formType: "file",
      usedFileType: "image/*",
      label: "Page Banner Image",
      placeholder: "Upload Page Banner Image",
      validation: { required: "At least one Image is required" },
    },
    {
      fieldName: "Page Title (EN)",
      fieldValue: "field_page_title_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_en",
      formType: "input",
      label: "Page Title (EN)",
      placeholder: "Enter Page Title (English)",
      validation: { required: "At least one title is required" },
    },
    {
      fieldName: "Page Title (MS)",
      fieldValue: "field_page_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_ms",
      formType: "input",
      label: "Page Title (MS)",
      placeholder: "Enter Page Title (Malay)",
    },
    {
      fieldName: "Page Title (ZH)",
      fieldValue: "field_page_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_zh",
      formType: "input",
      label: "Page Title (ZH)",
      placeholder: "Enter Page Title (Mandarin)",
    },
    {
      fieldName: "Page Description (EN)",
      fieldValue: "field_page_description_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_en",
      formType: "richText",
      label: "Page Description (EN)",
      placeholder: "Enter Page Description (English)",
      // validation: { required: "At least one Description is required" },
    },
    {
      fieldName: "Page Description (MS)",
      fieldValue: "field_page_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_ms",
      formType: "richText",
      label: "Page Description (MS)",
      placeholder: "Enter Page Description (Malay)",
    },
    {
      fieldName: "Page Description (ZH)",
      fieldValue: "field_page_description_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_zh",
      formType: "richText",
      label: "Page Description (ZH)",
      placeholder: "Enter Page Description (Mandarin)",
    },
  ],
  zonePublic: [
    {
      fieldName: "Title (EN)",
      fieldValue: "name",
      className: "col-span-6",
      type: "text",
      name: "name",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "name_ms",
      className: "col-span-6",
      type: "text",
      name: "name_ms",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "name_zh",
      className: "col-span-6",
      type: "text",
      name: "name_zh",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    },
  ],
  zonePassenger: [
    {
      fieldName: "Title (EN)",
      fieldValue: "name",
      className: "col-span-6",
      type: "text",
      name: "name",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "name_ms",
      className: "col-span-6",
      type: "text",
      name: "name_ms",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "name_zh",
      className: "col-span-6",
      type: "text",
      name: "name_zh",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    },
  ],
  zoneLevels: [
    {
      fieldName: "Title (EN)",
      fieldValue: "name",
      className: "col-span-6",
      type: "text",
      name: "name",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "name_ms",
      className: "col-span-6",
      type: "text",
      name: "name_ms",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "name_zh",
      className: "col-span-6",
      type: "text",
      name: "name_zh",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
    },
    {
      fieldName: "Airports",
      fieldValue: "airport",
      className: "col-span-6",
      type: "select",
      name: "airport",
      formType: "multiSelect",
      label: "Airports",
      placeholder: "Select applicable airports",
      options: [
        // { label: "KLIA1", value: "klia1" },
        // { label: "KLIA2", value: "klia2" },
        { label: "Langkawi", value: "langkawi" },
        { label: "Penang", value: "penang" },
        { label: "Kuching", value: "kuching" },
        { label: "Kota Kinabalu", value: "kota-kinabalu" },
      ],
      validation: { required: "At least one airport is required" },
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    },
  ],
  shopListPageContent: [
    {
      fieldName: "Image",
      fieldValue: "image",
      className: "col-span-6",
      type: "image",
      name: "image",
      formType: "file",
      usedFileType: "image/*",
      label: "Image",
      placeholder: "Select Image",
      validation: { required: "Image is required" },
    },
    {
      fieldName: "Title (EN)",
      fieldValue: "field_product_name_en",
      className: "col-span-6",
      type: "text",
      name: "field_product_name_en",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "field_product_name_ms",
      className: "col-span-6",
      type: "text",
      name: "field_product_name_ms",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "field_product_name_zh",
      className: "col-span-6",
      type: "text",
      name: "field_product_name_zh",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
    },
    {
      fieldName: "Category",
      fieldValue: "category",
      className: "col-span-6",
      type: "select",
      name: "category",
      formType: "select",
      label: "Category",
      placeholder: "Enter Category",
      loadOptions: fetchShopCategoryDropdown,
      validation: { required: "Category is required" },
    },
    {
      fieldName: "Zone",
      fieldValue: "zone",
      className: "col-span-6",
      type: "select",
      name: "zone",
      formType: "select",
      options: [
        {
          value: "Public",
          label: "Public",
        },
        {
          value: "Passenger",
          label: "Passenger",
        },
      ],
      label: "Zone",
      placeholder: "Select Zone",
      // validation: { required: "Zone is required" },
    },
    {
      fieldName: "Zone Level",
      fieldValue: "zoneLevel",
      className: "col-span-6",
      type: "select",
      name: "zoneLevel",
      loadOptions: async (selectedModule: any, currentAirport: any) => {
        return await FetchSubModule(selectedModule, currentAirport ?? "all");
      },
      formType: "select",
      label: "Zone Level",
      placeholder: "Enter Zone Level",
      validation: { required: "Zone Level is required" },
    },
    {
      fieldName: "Shop Store Hour (EN)",
      fieldValue: "field_shop_store_hour_value_en",
      className: "col-span-6",
      type: "text",
      name: "field_shop_store_hour_value_en",
      formType: "input",
      label: "Shop Store Hour (EN)",
      placeholder: "Enter Shop Store Hour (EN)",
      validation: { required: "Shop Store Hour (EN) is required" },
    },
    {
      fieldName: "Shop Store Hour (MS)",
      fieldValue: "field_shop_store_hour_value_ms",
      className: "col-span-6",
      type: "text",
      name: "field_shop_store_hour_value_ms",
      formType: "input",
      label: "Shop Store Hour (MS)",
      placeholder: "Enter Shop Store Hour (MS)",
    },
    {
      fieldName: "Shop Store Hour (ZH)",
      fieldValue: "field_shop_store_hour_value_zh",
      className: "col-span-6",
      type: "text",
      name: "field_shop_store_hour_value_zh",
      formType: "input",
      label: "Shop Store Hour (ZH)",
      placeholder: "Enter Shop Store Hour (ZH)",
    },
    {
      fieldName: "Shop Location (EN)",
      fieldValue: "field_shop_location_value_en",
      className: "col-span-6",
      type: "text",
      name: "field_shop_location_value_en",
      formType: "input",
      label: "Shop Location (EN)",
      placeholder: "Enter Shop Location (EN)",
      validation: { required: "Shop Location (EN) is required" },
    },
    {
      fieldName: "Shop Location (MS)",
      fieldValue: "field_shop_location_value_ms",
      className: "col-span-6",
      type: "text",
      name: "field_shop_location_value_ms",
      formType: "input",
      label: "Shop Location (MS)",
      placeholder: "Enter Shop Location (MS)",
    },
    {
      fieldName: "Shop Location (ZH)",
      fieldValue: "field_shop_location_value_zh",
      className: "col-span-6",
      type: "text",
      name: "field_shop_location_value_zh",
      formType: "input",
      label: "Shop Location (ZH)",
      placeholder: "Enter Shop Location (ZH)",
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    },
  ],
  servicesListPageContent: [
    {
      fieldName: "Image",
      fieldValue: "image",
      className: "col-span-6",
      type: "image",
      name: "image",
      formType: "file",
      usedFileType: "image/*",
      label: "Image",
      placeholder: "Select Image",
      validation: { required: "Image is required" },
    },
    {
      fieldName: "Title (EN)",
      fieldValue: "field_product_name_en",
      className: "col-span-6",
      type: "text",
      name: "field_product_name_en",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "field_product_name_ms",
      className: "col-span-6",
      type: "text",
      name: "field_product_name_ms",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "field_product_name_zh",
      className: "col-span-6",
      type: "text",
      name: "field_product_name_zh",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
    },
    {
      fieldName: "Category",
      fieldValue: "category",
      className: "col-span-6",
      type: "select",
      name: "category",
      formType: "select",
      label: "Category",
      placeholder: "Enter Category",
      loadOptions: fetchServicesCategoryDropdown,
      validation: { required: "Category is required" },
    },
    {
      fieldName: "Zone",
      fieldValue: "zone",
      className: "col-span-6",
      type: "select",
      name: "zone",
      formType: "select",
      options: [
        {
          value: "Public",
          label: "Public",
        },
        {
          value: "Passenger",
          label: "Passenger",
        },
      ],
      label: "Zone",
      placeholder: "Select Zone",
      // validation: { required: "Zone is required" },
    },
    {
      fieldName: "Zone Level",
      fieldValue: "zoneLevel",
      className: "col-span-6",
      type: "select",
      name: "zoneLevel",
      loadOptions: async (selectedModule: any, currentAirport: any) => {
        return await FetchSubModule(selectedModule, currentAirport ?? "all");
      },
      formType: "select",
      label: "Zone Level",
      placeholder: "Enter Zone Level",
      validation: { required: "Zone Level is required" },
    },
    {
      fieldName: "Shop Store Hour (EN)",
      fieldValue: "field_shop_store_hour_value_en",
      className: "col-span-6",
      type: "text",
      name: "field_shop_store_hour_value_en",
      formType: "input",
      label: "Shop Store Hour (EN)",
      placeholder: "Enter Shop Store Hour (EN)",
      validation: { required: "Shop Store Hour (EN) is required" },
    },
    {
      fieldName: "Shop Store Hour (MS)",
      fieldValue: "field_shop_store_hour_value_ms",
      className: "col-span-6",
      type: "text",
      name: "field_shop_store_hour_value_ms",
      formType: "input",
      label: "Shop Store Hour (MS)",
      placeholder: "Enter Shop Store Hour (MS)",
    },
    {
      fieldName: "Shop Store Hour (ZH)",
      fieldValue: "field_shop_store_hour_value_zh",
      className: "col-span-6",
      type: "text",
      name: "field_shop_store_hour_value_zh",
      formType: "input",
      label: "Shop Store Hour (ZH)",
      placeholder: "Enter Shop Store Hour (ZH)",
    },
    {
      fieldName: "Shop Location (EN)",
      fieldValue: "field_shop_location_value_en",
      className: "col-span-6",
      type: "text",
      name: "field_shop_location_value_en",
      formType: "input",
      label: "Shop Location (EN)",
      placeholder: "Enter Shop Location (EN)",
      validation: { required: "Shop Location (EN) is required" },
    },
    {
      fieldName: "Shop Location (MS)",
      fieldValue: "field_shop_location_value_ms",
      className: "col-span-6",
      type: "text",
      name: "field_shop_location_value_ms",
      formType: "input",
      label: "Shop Location (MS)",
      placeholder: "Enter Shop Location (MS)",
    },
    {
      fieldName: "Shop Location (ZH)",
      fieldValue: "field_shop_location_value_zh",
      className: "col-span-6",
      type: "text",
      name: "field_shop_location_value_zh",
      formType: "input",
      label: "Shop Location (ZH)",
      placeholder: "Enter Shop Location (ZH)",
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    },
  ],
  dineListPageContent: [
    {
      fieldName: "Image",
      fieldValue: "image",
      className: "col-span-6",
      type: "image",
      name: "image",
      formType: "file",
      usedFileType: "image/*",
      label: "Image",
      placeholder: "Select Image",
      validation: { required: "Image is required" },
    },
    {
      fieldName: "Title (EN)",
      fieldValue: "field_product_name_en",
      className: "col-span-6",
      type: "text",
      name: "field_product_name_en",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "field_product_name_ms",
      className: "col-span-6",
      type: "text",
      name: "field_product_name_ms",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "field_product_name_zh",
      className: "col-span-6",
      type: "text",
      name: "field_product_name_zh",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
    },
    {
      fieldName: "Category",
      fieldValue: "category",
      className: "col-span-6",
      type: "select",
      name: "category",
      formType: "select",
      label: "Category",
      placeholder: "Enter Category",
      loadOptions: fetchDineCategoryDropdown,
      validation: { required: "Category is required" },
    },
    {
      fieldName: "Zone",
      fieldValue: "zone",
      className: "col-span-6",
      type: "select",
      name: "zone",
      formType: "select",
      options: [
        {
          value: "Public",
          label: "Public",
        },
        {
          value: "Passenger",
          label: "Passenger",
        },
      ],
      label: "Zone",
      placeholder: "Select Zone",
      // validation: { required: "Zone is required" },
    },
    {
      fieldName: "Zone Level",
      fieldValue: "zoneLevel",
      className: "col-span-6",
      type: "select",
      name: "zoneLevel",
      loadOptions: async (selectedModule: any, currentAirport: any) => {
        return await FetchSubModule(selectedModule, currentAirport ?? "all");
      },
      formType: "select",
      label: "Zone Level",
      placeholder: "Enter Zone Level",
      validation: { required: "Zone Level is required" },
    },
    {
      fieldName: "Shop Store Hour (EN)",
      fieldValue: "field_shop_store_hour_value_en",
      className: "col-span-6",
      type: "text",
      name: "field_shop_store_hour_value_en",
      formType: "input",
      label: "Shop Store Hour (EN)",
      placeholder: "Enter Shop Store Hour (EN)",
      validation: { required: "Shop Store Hour (EN) is required" },
    },
    {
      fieldName: "Shop Store Hour (MS)",
      fieldValue: "field_shop_store_hour_value_ms",
      className: "col-span-6",
      type: "text",
      name: "field_shop_store_hour_value_ms",
      formType: "input",
      label: "Shop Store Hour (MS)",
      placeholder: "Enter Shop Store Hour (MS)",
    },
    {
      fieldName: "Shop Store Hour (ZH)",
      fieldValue: "field_shop_store_hour_value_zh",
      className: "col-span-6",
      type: "text",
      name: "field_shop_store_hour_value_zh",
      formType: "input",
      label: "Shop Store Hour (ZH)",
      placeholder: "Enter Shop Store Hour (ZH)",
    },
    {
      fieldName: "Shop Location (EN)",
      fieldValue: "field_shop_location_value_en",
      className: "col-span-6",
      type: "text",
      name: "field_shop_location_value_en",
      formType: "input",
      label: "Shop Location (EN)",
      placeholder: "Enter Shop Location (EN)",
      validation: { required: "Shop Location (EN) is required" },
    },
    {
      fieldName: "Shop Location (MS)",
      fieldValue: "field_shop_location_value_ms",
      className: "col-span-6",
      type: "text",
      name: "field_shop_location_value_ms",
      formType: "input",
      label: "Shop Location (MS)",
      placeholder: "Enter Shop Location (MS)",
    },
    {
      fieldName: "Shop Location (ZH)",
      fieldValue: "field_shop_location_value_zh",
      className: "col-span-6",
      type: "text",
      name: "field_shop_location_value_zh",
      formType: "input",
      label: "Shop Location (ZH)",
      placeholder: "Enter Shop Location (ZH)",
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    },
  ],
  shopAndDineLabelsData: [
    {
      fieldName: "Search Text (EN)",
      fieldValue: "field_content_en.detailPage.labelData.searchText",
      className: "col-span-6",
      type: "text",
      name: "field_content_en_labelData_searchText",
      formType: "input",
      label: "Search Text (EN)",
      placeholder: "Enter Search Text (EN)",
      validation: { required: "Search Text (EN) is required" },
    },
    {
      fieldName: "Search Text (MS)",
      fieldValue: "field_content_ms.detailPage.labelData.searchText",
      className: "col-span-6",
      type: "text",
      name: "field_content_ms_labelData_searchText",
      formType: "input",
      label: "Search Text (MS)",
      placeholder: "Enter Search Text (MS)",
    },
    {
      fieldName: "Search Text (ZH)",
      fieldValue: "field_content_zh.detailPage.labelData.searchText",
      className: "col-span-6",
      type: "text",
      name: "field_content_zh_labelData_searchText",
      formType: "input",
      label: "Search Text (ZH)",
      placeholder: "Enter Search Text (ZH)",
    },
    {
      fieldName: "Public Text (EN)",
      fieldValue: "field_content_en.detailPage.data.zones[0].label",
      className: "col-span-6",
      type: "text",
      name: "field_content_en_data_zones_0_label",
      formType: "input",
      label: "Public Text (EN)",
      placeholder: "Enter Public Text (EN)",
      validation: { required: "Public Text (EN) is required" },
    },
    {
      fieldName: "Public Text (MS)",
      fieldValue: "field_content_ms.detailPage.data.zones[0].label",
      className: "col-span-6",
      type: "text",
      name: "field_content_ms_data_zones_0_label",
      formType: "input",
      label: "Public Text (MS)",
      placeholder: "Enter Public Text (MS)",
    },
    {
      fieldName: "Public Text (ZH)",
      fieldValue: "field_content_zh.detailPage.data.zones[0].label",
      className: "col-span-6",
      type: "text",
      name: "field_content_zh_data_zones_0_label",
      formType: "input",
      label: "Search Public (ZH)",
      placeholder: "Enter Public Text (ZH)",
    },
    {
      fieldName: "Passenger Text (EN)",
      fieldValue: "field_content_en.detailPage.data.zones[1].label",
      className: "col-span-6",
      type: "text",
      name: "field_content_en_data_zones_1_label",
      formType: "input",
      label: "Passenger Text (EN)",
      placeholder: "Enter Passenger Text (EN)",
      validation: { required: "Passenger Text (EN) is required" },
    },
    {
      fieldName: "Passenger Text (MS)",
      fieldValue: "field_content_ms.detailPage.data.zones[1].label",
      className: "col-span-6",
      type: "text",
      name: "field_content_ms_data_zones_1_label",
      formType: "input",
      label: "Passenger Text (MS)",
      placeholder: "Enter Passenger Text (MS)",
    },
    {
      fieldName: "Passenger Text (ZH)",
      fieldValue: "field_content_zh.detailPage.data.zones[1].label",
      className: "col-span-6",
      type: "text",
      name: "field_content_zh_data_zones_1_label",
      formType: "input",
      label: "Search Passenger (ZH)",
      placeholder: "Enter Passenger Text (ZH)",
    },

    {
      fieldName: "Category Text (EN)",
      fieldValue: "field_content_en.detailPage.labelData.categoryText",
      className: "col-span-6",
      type: "text",
      name: "field_content_en_labelData_categoryText",
      formType: "input",
      label: "Category Text (EN)",
      placeholder: "Enter Category Text (EN)",
      validation: { required: "Category Text (EN) is required" },
    },
    {
      fieldName: "Category Text (MS)",
      fieldValue: "field_content_ms.detailPage.labelData.categoryText",
      className: "col-span-6",
      type: "text",
      name: "field_content_ms_labelData_categoryText",
      formType: "input",
      label: "Category Text (MS)",
      placeholder: "Enter Category Text (MS)",
    },
    {
      fieldName: "Category Text (ZH)",
      fieldValue: "field_content_zh.detailPage.labelData.categoryText",
      className: "col-span-6",
      type: "text",
      name: "field_content_zh_labelData_categoryText",
      formType: "input",
      label: "Search Category (ZH)",
      placeholder: "Enter Category Text (ZH)",
    },
    {
      fieldName: "Zone Text (EN)",
      fieldValue: "field_content_en.detailPage.labelData.zoneText",
      className: "col-span-6",
      type: "text",
      name: "field_content_en_labelData_zoneText",
      formType: "input",
      label: "Zone Text (EN)",
      placeholder: "Enter Zone Text (EN)",
      validation: { required: "Zone Text (EN) is required" },
    },
    {
      fieldName: "Zone Text (MS)",
      fieldValue: "field_content_ms.detailPage.labelData.zoneText",
      className: "col-span-6",
      type: "text",
      name: "field_content_ms_labelData_zoneText",
      formType: "input",
      label: "Zone Text (MS)",
      placeholder: "Enter Zone Text (MS)",
    },
    {
      fieldName: "Zone Text (ZH)",
      fieldValue: "field_content_zh.detailPage.labelData.zoneText",
      className: "col-span-6",
      type: "text",
      name: "field_content_zh_labelData_zoneText",
      formType: "input",
      label: "Search Zone (ZH)",
      placeholder: "Enter Zone Text (ZH)",
    },
    {
      fieldName: "Level Text (EN)",
      fieldValue: "field_content_en.detailPage.labelData.levelText",
      className: "col-span-6",
      type: "text",
      name: "field_content_en_labelData_levelText",
      formType: "input",
      label: "Level Text (EN)",
      placeholder: "Enter Level Text (EN)",
      validation: { required: "Level Text (EN) is required" },
    },
    {
      fieldName: "Level Text (MS)",
      fieldValue: "field_content_ms.detailPage.labelData.levelText",
      className: "col-span-6",
      type: "text",
      name: "field_content_ms_labelData_levelText",
      formType: "input",
      label: "Level Text (MS)",
      placeholder: "Enter Level Text (MS)",
    },
    {
      fieldName: "Level Text (ZH)",
      fieldValue: "field_content_zh.detailPage.labelData.levelText",
      className: "col-span-6",
      type: "text",
      name: "field_content_zh_labelData_levelText",
      formType: "input",
      label: "Search Level (ZH)",
      placeholder: "Enter Level Text (ZH)",
    },
  ],
};
